module.exports = __webpack_public_path__ + "static/media/channels.3f78b1eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/channels.svg
// module id = 91
// module chunks = 0